import { create } from 'zustand';

type ModalStore = {
  showModalCustomerValidation: boolean;
  setShowModalCustomerValidation(value: boolean): void;

  urlValidation: string;
  setUrlValidation(value: string): void;

  closeModal(): void;
};

export const useModalStore = create<ModalStore>((set) => ({
  showModalCustomerValidation: false,
  setShowModalCustomerValidation(value: boolean) {
    set((state) => ({ ...state, showModalCustomerValidation: value }));
  },

  urlValidation: '',
  setUrlValidation(value: string) {
    set((state) => ({ ...state, urlValidation: value }));
  },

  closeModal() {
    set((state) => ({
      ...state,
      showModalCustomerValidation: false,
    }));
  },
}));
